<template>
  <div>
    <form id="form1">
      <div class='row h-row-inputBox h-tableHeight130'>
        <div class='col-sm-6 h-col-inputBox'>
          <div class='h-inputLit'>{{$t('TS.starttime')}}:</div>
          <ejs-datepicker format='yyyy-MM-dd' v-model='startdate' name="startDateTime" :allowEdit="allowEdit" :locale="locale" :showClearButton="showClearButton"></ejs-datepicker>
        </div>
        <div class='col-sm-6 h-col-inputBox'>
          <div class='h-inputLit'>{{$t('TS.endtime')}}:</div>
          <ejs-datepicker format='yyyy-MM-dd' v-model='enddate' name="endDateTime" :allowEdit="allowEdit" :locale="locale" :showClearButton="showClearButton"></ejs-datepicker>
        </div>
        <div v-show='showIntevalOption' class='col-sm-6 h-col-inputBox' style="padding-top: 15px;">
          <div class='h-inputLit'>{{$t('TS.interval')}}:</div>
          <ejs-dropdownlist id="float" :fields = "fields" :index = "currentIndex" :dataSource = "items" :popupHeight= "popupHeight" v-model='timeInterval'>
          </ejs-dropdownlist>
        </div>
      </div>
      <div class="h-borderBox height-280" style="padding-top: 15px;">
        <div class="h-borderBox-top" style="height: 40px; background-color: #e6f7ff;">
          <div style="padding-top: 15px;padding-left:5px">{{$t('TS.ts_neList')}}</div>
        </div>
        <NeList ref='neInfo' :neArr='netype' :select='neClick' name="selectNeTree"></NeList>
      </div>
    </form>
  </div>
</template>

<script>
import Vue from 'vue';
import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';
import { TextBoxPlugin, NumericTextBoxPlugin, FormValidator } from '@syncfusion/ej2-vue-inputs';
import { CheckBoxPlugin } from '@syncfusion/ej2-vue-buttons';
import { DropDownListPlugin } from '@syncfusion/ej2-vue-dropdowns';
import NeList from '../common/NeList';
import { EventBus } from '../../plugins/eventBus';

Vue.use(TextBoxPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(DropDownListPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(DatePickerPlugin);
export default {
  name: 'QueryDataDialog',
  components: {
    NeList
  },
  props: {
    showIntevalOption: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  data() {
    return {
      showClearButton: false,
      // locale: localStorage.getItem('locale'),
      locale: this.LOCALE,
      allowEdit: false,
      startdate: this.formatDataStr(new Date()),
      enddate: this.formatDataStr(new Date()),
      neId: '',
      timeInterval: 0,
      formObj: '',
      netype: [
        16, // mcs_pf
        2111//wp
        // 28 // pcdr
      ],
      items: [
        { sizeVal: 0, sizeTxt: this.$t('TS.time15min') },
        { sizeVal: 1, sizeTxt: this.$t('TS.time1hour') },
        { sizeVal: 2, sizeTxt: this.$t('TS.time1day') },
      ],
      fields: { text: 'sizeTxt', value: 'sizeVal' },
      popupHeight: 200,
      currentIndex: 0
    };
  },
  watch: {
    startdate(val) {
      this.startdate = this.formatDataStr(val);
    },
    enddate(val) {
      this.enddate = this.formatDataStr(val);
    }
  },
  mounted() {
    const options = {
      rules: {
        selectNeTree: { required: [true, 'Select any value'] }
      }
    };
    this.formObj = new FormValidator('#form1', options);
  },
  methods: {
    neClick() {
      this.neId = this.$refs.neInfo.getNe().data.id;
    },
    getSearchCondition() {
      if (this.startdate === '') {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('TS.startDateIsNull') })
        return;
      }
      if (this.enddate === '') {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('TS.endDateIsNull') })
        return;
      }
      // this.neId = 2035;
      if (this.neId === '') {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('TS.neIDIsNull') })
        return;
      }
      if (new Date(this.startdate).getTime() > new Date(this.enddate).getTime()) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('TS.startDateGreaterEndDate') })
        return;
      }
      if(!this.showIntevalOption) {
        this.timeInterval = 2;
      }
      if ((this.timeInterval === 0 || this.timeInterval === 1) && (new Date(this.startdate).getTime() !== new Date(this.enddate).getTime())) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('TS.startDateEqualsEndDate') })
        return;
      }
      // if (this.timeInterval === 2 && new Date(this.startdate).getTime() === new Date(this.enddate).getTime()) {
      //   EventBus.$emit('toast', { type: 'warning', content: this.$t('TS.startDateNoEqualsEndDate') })
      //   return;
      // }
      if (new Date(this.enddate).getTime() - new Date(this.startdate).getTime() > 2678400000) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('TS.startDateMaxEndDate') })
        return;
      }
      return {
        timeInterval: this.timeInterval,
        neId: this.neId,
        startdate: this.startdate,
        enddate: this.enddate
      };
    },
    formatDataStr(val) {
      const dateValue = new Date(val);
      let month = dateValue.getMonth() + 1;
      if (month < 10) {
        month = `0${month}`;
      }
      let day = dateValue.getDate();
      if (day < 10) {
        day = `0${day}`;
      }
      return `${dateValue.getFullYear()}-${month}-${day}`;
    }
  }
};
</script>

<style>
</style>
